import { useCallback } from 'react';

import type { CreateLabOrderRequest } from '../types';

import {
  useGetV2ProviderLabsAvailableQuery,
  usePostV2ProviderLabsOrdersGeneratePdfMutation,
  usePostV2ProviderLabsOrdersMutation,
} from './api';

// Placeholder hooks - will implement in Phase 2
export function useCreateLabOrder() {
  const [createLabOrder, result] = usePostV2ProviderLabsOrdersMutation();

  const mutate = useCallback(
    (
      args: { createLabOrderRequest: CreateLabOrderRequest },
      options?: { onSuccess?: () => void; onError?: (error: unknown) => void },
    ) => {
      const promise = createLabOrder(args);

      if (options) {
        promise
          .unwrap()
          .then(() => options.onSuccess?.())
          .catch((error: unknown) => options.onError?.(error));
      }

      return promise;
    },
    [createLabOrder],
  );

  return { mutate, ...result };
}

export function useAvailableLabTests() {
  const { data, ...rest } = useGetV2ProviderLabsAvailableQuery();

  return {
    ...rest,
    labTests: data?.lab_tests || [],
    labBundles: data?.lab_bundles || [],
  };
}

export function useLabOrderPdf() {
  const [generatePdf, result] = usePostV2ProviderLabsOrdersGeneratePdfMutation();

  const generate = useCallback(
    (
      request: CreateLabOrderRequest,
      options?: { onSuccess?: (pdf: { filename: string; pdf_data: string }) => void },
    ) => {
      return generatePdf({ createLabOrderRequest: request })
        .unwrap()
        .then(response => {
          if (options?.onSuccess) {
            options.onSuccess(response);
          }
          return response;
        });
    },
    [generatePdf],
  );

  return { generate, ...result };
}

// Re-export PDF utility
export { openPdfInNewTab } from '../utils/pdf';
